export function sharePannel() {
  var system = navigator.userAgent;
  let os;
  //  os => 获取操作系统信息  iPhone(1)  Android(2)
  if (/iphone|ipod/i.test(system)) {
    os = 1;
  } else if (/android/i.test(system)) {
    os = 2;
  } else {
    os = 0;
  }

  //  UA => appVersion 属性可返回浏览器的平台和版本信息。
  var UA = navigator.appVersion;

  // 是否是 UC 浏览器
  var uc = UA.split('UCBrowser/').length > 1 ? 1 : 0;

  //  判断 qq 浏览器
  //  然而qq浏览器分高低版本
  //  2 代表高版本
  //  1 代表低版本
  var qq = UA.split('MQQBrowser/').length > 1 ? 2 : 0;

  // qqVs/ucVs 浏览器版本;
  var qqVs = qq ? parseFloat(UA.split('MQQBrowser/')[1]) : 0;
  var ucVs = uc ? parseFloat(UA.split('UCBrowser/')[1]) : 0;

  // 进一步细化版本和平台判断
  if ((qq && qqVs < 5.4 && os == 1) || (qq && qqVs < 5.3 && os == 1)) {
    qq = 0;
  } else {
    if (qq && qqVs < 5.4 && os == 2) {
      qq = 1;
    } else {
      if (uc && ((ucVs < 10.2 && os == 1) || (ucVs < 9.7 && os == 2))) {
        uc = 0;
      }
    }
  }

  var script = document.createElement('script');
  script.src = +qq === 1 ? '//3gimg.qq.com/html5/js/qb.js' : '//jsapi.qq.com/get?api=app.share';
  /**
   * 需要等加载过 qq 的 bridge 脚本之后
   * 再去初始化分享组件
   */
  // script.onload = function() {
  //   cb && cb();
  // };
  document.body.appendChild(script);

  // uc 和qq 可以有微信和朋友圈分享
  if (uc) {
    return 'ucShare';
  } else if (qq) {
    return 'qqShare';
  } else {
    // 只有复制链接
    return 'noshare';
  }
}

export function switchShare(shareType, currentbrowser, config) {
  var system = navigator.userAgent;
  let os;
  //  os => 获取操作系统信息  iPhone(1)  Android(2)
  if (/iphone|ipod/i.test(system)) {
    os = 1;
  } else if (/android/i.test(system)) {
    os = 2;
  } else {
    os = 0;
  }
  var qqBridgeLoaded = false;

  //  UA => appVersion 属性可返回浏览器的平台和版本信息。
  var UA = navigator.appVersion;

  // 是否是 UC 浏览器
  var uc = UA.split('UCBrowser/').length > 1 ? 1 : 0;

  //  判断 qq 浏览器
  //  然而qq浏览器分高低版本
  //  2 代表高版本
  //  1 代表低版本
  var qq = UA.split('MQQBrowser/').length > 1 ? 2 : 0;

  // qqVs/ucVs 浏览器版本;
  var qqVs = qq ? parseFloat(UA.split('MQQBrowser/')[1]) : 0;
  var ucVs = uc ? parseFloat(UA.split('UCBrowser/')[1]) : 0;

  // 进一步细化版本和平台判断
  if ((qq && qqVs < 5.4 && os == 1) || (qq && qqVs < 5.3 && os == 1)) {
    qq = 0;
  } else {
    if (qq && qqVs < 5.4 && os == 2) {
      qq = 1;
    } else {
      if (uc && ((ucVs < 10.2 && os == 1) || (ucVs < 9.7 && os == 2))) {
        uc = 0;
      }
    }
  }
  var loadqqApi = function(cb) {
    // qq == 0
    if (!qq) {
      return cb && cb();
    }
    var script = document.createElement('script');
    // qq == 1 低版本
    // qq == 2 高版本
    script.src = +qq === 1 ? '//3gimg.qq.com/html5/js/qb.js' : '//jsapi.qq.com/get?api=app.share';
    script.onload = function() {
      cb && cb();
    };
    document.body.appendChild(script);
  };
  loadqqApi(function() {
    qqBridgeLoaded = true;
  });
  /**
   * 是否是微信
   */
  var wx = /micromessenger/i.test(UA);
  if (currentbrowser == 'uc') {
    config.type = shareType;
    // ['title', 'content', 'url', 'platform', 'disablePlatform', 'source', 'htmlID']
    // 关于platform
    // ios: kWeixin || kWeixinFriend;
    // android: WechatFriends || WechatTimeline
    // uc 分享会直接使用截图
    var platform = '';
    var shareInfo = null;
    // 指定了分享类型
    if (config.type) {
      if (os == 2) {
        platform = config.type == 1 ? 'WechatTimeline' : 'WechatFriends';
      } else if (os == 1) {
        platform = config.type == 1 ? 'kWeixinFriend' : 'kWeixin';
      }
    }
    shareInfo = [config.title, config.desc, config.url, platform, '', '', ''];
    // android
    if (window.ucweb) {
      ucweb.startRequest && ucweb.startRequest('shell.page_share', shareInfo);
      return;
    }
    if (window.ucbrowser) {
      ucbrowser.web_share && ucbrowser.web_share.apply(null, shareInfo);
      return;
    }
  } else if (currentbrowser == 'qq') {
    var type = shareType;
    // //微信好友 1, 微信朋友圈 8
    type = type ? (type == 1 ? 8 : 1) : '';
    var share = function() {
      var shareInfo = {
        url: config.url,
        title: config.title,
        description: config.desc,
        img_url: config.img,
        img_title: config.title,
        to_app: type,
        cus_txt: '',
      };
      if (window.browser) {
        browser.app && browser.app.share(shareInfo);
      } else if (window.qb) {
        qb.share && qb.share(shareInfo);
      }
    };
    if (qqBridgeLoaded) {
      share();
    } else {
      loadqqApi(share);
    }
  }
}
